module.exports = __webpack_public_path__ + "img/icon-dapp-aave.b2663553.svg";